import { render, staticRenderFns } from "./storage-quota.vue?vue&type=template&id=a84c38a6&scoped=true&"
import script from "./storage-quota.vue?vue&type=script&lang=js&"
export * from "./storage-quota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84c38a6",
  null
  
)

export default component.exports